<template>
   <div>
       <HeadDetailsGama :titleHead="'Detalhes Consulta de Comissões'"></HeadDetailsGama>

              <Tables ref="tableGridParcela"
              :columns="headTable"
              :showSearch="false"
              :showPrint="false"
              :showHeader="false"
              :showPaging="false"
              :showDownload="false"
              :showFullscreen="false"
              :showClickToSelect="false"
              v-on:Load="onLoad"
            >
              <tr v-for="parcela in consultaparcela" v-bind:key="parcela.id">
                <TableColumn :IsText="true"    :status="1" :value="parcela.valorParcelaFormatada" />
                <TableColumn :IsText="true"    :status="1" :value="parcela.dataVencimentoFormatada" />
                <TableColumn :newState="true"  :newStatusNumber="parcela.status" :descriptionNewStatus="['Quitado','Vencido', 'A Receber'][parcela.status]" />
              </tr>
            </Tables>
   </div>
</template>

<script>
import CommissionformAdm from './commissionformAdm'
export default CommissionformAdm
</script>

<style scoped>
.title-1{
  grid-row: 1;
  grid-column: 1/5;
  color: #008148;
  font-size: 19px;
  margin-top: 20px;
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissions/components/commissionformAdm/commissionformAdm.vue